// The Command Center HUD is reachable at a stable, Cloudflare-Access-locked
// tunnel in production (command.getavium.com — only Brian's identity gets in);
// in local dev it's the Vite HUD on :4601. Override with VITE_COMMAND_CENTER_URL
// if the host ever changes, so this isn't a hard-coded literal. One home for
// the resolution — the "jarvis" easter egg and the account-menu link both read
// from here.
export const COMMAND_CENTER_URL =
  (import.meta.env.VITE_COMMAND_CENTER_URL as string | undefined) ||
  (import.meta.env.PROD ? 'https://command.getavium.com' : 'http://localhost:4601');
